module.exports = __webpack_public_path__ + "img/hide-english-one.ddb521d2.png";